var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { START_LOADING, LOADING_SUCCESSFUL, LOADING_FAILED, SET_QUERY_STRING, SET_REQUEST_QUERY_STRING, RESET_API_RESPONSE } from "../actions/response.actions";
import get from "lodash/get";
import immutableSet from "lodash/fp/set";
import { RESET_BOOK_DATA } from "../actions";
import { API_METHODS_ENUM } from "../../httpService";
export var getPaginatedRecordsPath = function (name, isPaginated) {
    if (!isPaginated)
        return name;
    return name + "__paginated.records";
};
export var responseReducer = function (state, _a) {
    var _b, _c;
    if (state === void 0) { state = {}; }
    var type = _a.type, name = _a.name, _d = _a.resetResponse, resetResponse = _d === void 0 ? true : _d, resetAllPages = _a.resetAllPages, pageNumber = _a.pageNumber, actionProps = __rest(_a, ["type", "name", "resetResponse", "resetAllPages", "pageNumber"]);
    var isPaginated = !isNaN(pageNumber);
    var recordsPath = getPaginatedRecordsPath(name, isPaginated);
    name = [recordsPath, isPaginated ? pageNumber - 1 : null].filter(function (x) { return x !== null; }).join(".");
    switch (type) {
        case SET_REQUEST_QUERY_STRING: return immutableSet(name, __assign(__assign({}, get(state, name, isPaginated ? [] : {})), { requestQueryString: actionProps.queryString, queryString: null }), state);
        case SET_QUERY_STRING: return immutableSet(name, __assign(__assign({}, get(state, name, {})), { queryString: actionProps.queryString }), state);
        case START_LOADING:
            if (resetResponse && isPaginated) {
                return immutableSet(recordsPath, get(state, recordsPath, []).slice(0, pageNumber), state);
            }
            return immutableSet(name, {
                response: resetResponse ? null : ((_b = state[name]) === null || _b === void 0 ? void 0 : _b.response) || null,
                error: null
            }, state);
        case LOADING_SUCCESSFUL: {
            if (resetAllPages && isPaginated)
                state = immutableSet(recordsPath, get(state, recordsPath, []).map(function () { return ({}); }), state);
            return immutableSet(name, __assign(__assign({}, get(state, name, {})), actionProps), state);
        }
        case LOADING_FAILED:
            return immutableSet(name, __assign(__assign(__assign({}, state[name]), actionProps), { response: resetResponse ? null : ((_c = state[name]) === null || _c === void 0 ? void 0 : _c.response) || null }), state);
        case RESET_BOOK_DATA: {
            state = __assign({}, state);
            var apiPath = getPaginatedRecordsPath(API_METHODS_ENUM.GET_BOOK_ENTITIES, isPaginated).replace(".records", "");
            delete state[apiPath];
            return state;
        }
        case RESET_API_RESPONSE: {
            state = __assign({}, state);
            delete state[name];
            return state;
        }
    }
    return state;
};
